import { TASK_LIST_PATH } from "pages/project/task/task.typing";
import { cn } from "utils/ui";

/**
 * Pages that scroll their list inside the viewport instead of scrolling the window, so the detail
 * SideBar next to the list stays on screen. lg+ only: below lg the list and the panel are not side by
 * side, and the fixed chrome (navbar, banner, tabs, filters, footer) would leave no room for the list.
 */
export function isViewportLockedPath(pathname: string): boolean {
  return pathname === TASK_LIST_PATH || pathname.startsWith(`${TASK_LIST_PATH}/`);
}

export function appShellClassName(isViewportLocked: boolean) {
  return cn("flex h-full flex-col", { "lg:overflow-hidden": isViewportLocked });
}

export function appMainClassName(isViewportLocked: boolean) {
  return cn("flex-1 border-y border-slate-200 bg-gray-100 dark:border-slate-600 dark:bg-gray-700", {
    "lg:flex lg:min-h-0 lg:flex-col lg:overflow-hidden": isViewportLocked,
  });
}

export function appOutletClassName(isViewportLocked: boolean) {
  return cn({ "lg:flex lg:min-h-0 lg:flex-1 lg:flex-col": isViewportLocked });
}
